import Cookies from './Cookies';
export default Cookies;



//////////////////
// WEBPACK FOOTER
// ./~/universal-cookie/es6/index.js
// module id = 3555
// module chunks = 0